export const BASETOGGLE =
  'border rounded-full w-full min-h-[48px] text-center leading-0.5 px-4 focus:outline-none transform transition-transform duration-150';
export const ACTIVETOGGLE = `${BASETOGGLE} text-white bg-violet-200 border-violet-200 shadow-6dp hover:scale-105 focus:scale-105`;
export const INACTIVETOGGLE = `${BASETOGGLE} text-text1 bg-white border-gray-400 hover:shadow-8dp hover:scale-110 focus:shadow-8dp focus:scale-110`;
